<script setup lang="ts">
/**
 * The one thing the app cannot work out for itself: how big the boat is. Every depth
 * and bridge answer leans on these four numbers, and a default draught of 70 cm is a
 * dangerous thing to leave sitting there unread. So the first time the app is really
 * in use it asks, once, with the same steppers Settings uses.
 */
import { ref } from 'vue'
import { useAppStore } from '../store'
import { MEASURES } from '../lib/boat'
import MeasureStepper from './MeasureStepper.vue'

const store = useAppStore()
const later = ref(false)

function done() {
  store.settings.boatConfirmed = true
}
</script>

<template>
  <div v-if="store.settings.entrySeen && !store.settings.boatConfirmed && !later" class="modal">
    <div class="card">
      <h1>{{ store.t('boatSetupTitle') }}</h1>
      <p>{{ store.t('boatSetupIntro') }}</p>
      <div v-for="m in MEASURES" :key="m.key" class="measure">
        <div class="label">
          <span>{{ store.t(m.label) }}</span>
          <span class="small muted">{{ store.t(m.help) }}</span>
        </div>
        <MeasureStepper v-model="store.settings[m.key]" :coarse="m.coarse" :fine="m.fine" :min="m.min" :max="m.max" />
      </div>
      <div class="cardbuttons">
        <button class="link" @click="later = true">{{ store.t('later') }}</button>
        <button class="primary big" @click="done()">{{ store.t('done') }}</button>
      </div>
    </div>
  </div>
</template>
